import { useGetReceivablesReportQuery } from "@states/report/report.api";
import { TSuccessResponse } from "@type-defs/general/TSuccessResponse";

const useGetReceivablesReport = (args: {
  from_date?: string;
  to_date?: string;
  customer_id?: number;
}) => {
  const {
    data: rawData,
    error,
    isLoading,
    refetch,
    isFetching,
  } = useGetReceivablesReportQuery({ ...args });

  const receivablesResponse = rawData as any as TSuccessResponse<any>;

  return {
    receivablesData: receivablesResponse?.data,
    receivablesMessage: receivablesResponse?.message,
    receivablesSuccess: receivablesResponse?.success,
    receivablesError: error,
    receivablesLoading: isLoading,
    receivablesRefetch: refetch,
    receivablesFetching: isFetching,
  };
};

export default useGetReceivablesReport;
